export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11535.a5bfe4f4.jpg";